<template>
  <label for="price" class="g--label mt-4  mb-1">
    Price
  </label>
  <p class="text-sm text-gray-800 mb-4">
    Update one price and the other two will be calculated automatically.<br/>
    The minimum price for a class is £5 / $6 / 6€.
  </p>
  <div class="flex flex-col sm:flex-row sm:items-center  gap-x-8 gap-y-4">
    <div class="flex max-w-[140px] items-center">
      <span class="mr-2 flex-shrink-0">£ GBP</span>
      <input
          type="number"
          v-model="priceData.priceGBP"

          @blur="updatePrices('GBP')"
          class="w-full border rounded px-3 py-2"
          step="1"
          min="5"
      >
    </div>
    <div class="flex max-w-[140px] items-center">
      <span class="mr-2 flex-shrink-0">$ USD</span>
      <input
          type="number"
          v-model="priceData.priceUSD"

          @blur="updatePrices('USD')"
          class="w-full border rounded px-3 py-2"
          step="1"
          min="5"
      >
    </div>
    <div class="flex max-w-[140px] items-center">
      <span class="mr-2 flex-shrink-0">€ EUR</span>
      <input
          type="number"
          v-model="priceData.priceEUR"

          @blur="updatePrices('EUR')"
          class="w-full border rounded px-3 py-2"
          step="1"
          min="5"
      >
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  classItem: {
    type: Object,
    required: true,
  },
});

const priceData = ref({
  priceGBP: props.classItem.priceGBP,
  priceUSD: props.classItem.priceUSD,
  priceEUR: props.classItem.priceEUR
});


const exchangeRates = ref({
  GBP_USD: 1.26,
  GBP_EUR: 1.20
});

// Helper function to match PHP's ROUND_HALF_UP behavior
const roundHalfUp = (num) => {
  return Math.round(num + (Number.EPSILON * Math.sign(num)));
};
const emit = defineEmits(['update:price']);
const updatePrices = (sourceCurrency) => {
  console.log('upading price');
  let sourceAmount = priceData.value[`price${sourceCurrency}`];

  if (!sourceAmount || sourceAmount < 5) {
    priceData.value.priceGBP = '5';
    priceData.value.priceUSD = roundHalfUp(5 * exchangeRates.value.GBP_USD);
    priceData.value.priceEUR = roundHalfUp(5 * exchangeRates.value.GBP_EUR);
    sourceAmount = 5;
    sourceCurrency = 'GBP';
    // return;
  }

  if (sourceCurrency === 'USD') {
    priceData.value.priceGBP = roundHalfUp(sourceAmount / exchangeRates.value.GBP_USD);
    priceData.value.priceUSD = roundHalfUp(sourceAmount);
    priceData.value.priceEUR = roundHalfUp(sourceAmount * exchangeRates.value.GBP_USD / exchangeRates.value.GBP_EUR);
  } else if (sourceCurrency === 'EUR') {
    priceData.value.priceGBP = roundHalfUp(sourceAmount / exchangeRates.value.GBP_EUR);
    priceData.value.priceUSD = roundHalfUp(sourceAmount * exchangeRates.value.GBP_EUR / exchangeRates.value.GBP_USD);
    priceData.value.priceEUR = roundHalfUp(sourceAmount);
  } else {
    // GBP is source
    priceData.value.priceGBP = roundHalfUp(sourceAmount);
    priceData.value.priceUSD = roundHalfUp(sourceAmount * exchangeRates.value.GBP_USD);
    priceData.value.priceEUR = roundHalfUp(sourceAmount * exchangeRates.value.GBP_EUR);
  }

  emit('update:price', priceData.value);
};

</script>